import {FULFILLED} from 'redux-promise-middleware';
import {takeEvery, call, select} from 'redux-saga/effects';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';

import {CATEGORY} from 'constants/actions';
import {getCategory} from 'selectors/category/category';
import {PAGE_NAME_FOR_VIZURY, pushVizury} from 'libs/analytics/vizury';

/**
 * Send data for Data Layer
 */
export function* sendDataLayerData() {
    const {title: category} = yield select(getCategory);
    yield call(pushVizury, PAGE_NAME_FOR_VIZURY.CATEGORY, category);
    yield call(pushDataLayer, {
        category,
    });
}

/**
 * Category saga analytics
 */
export default function* analytics() {
    yield takeEvery(`${CATEGORY.GET_CATEGORY}_${FULFILLED}`, sendDataLayerData);
}
